// **** import modules ****
import $ from "jquery";
import vuwer from "@@assets/scripts/vuwer";


// **** process ****
vuwer.add("pageMain", {
	selector: "#page_main",
	onReady($self) {
		if(!$self) {
			return false;
		}
		
		const $sessionSections = $self.children(".session-section");
		if($sessionSections.length) {
			$sessionSections.each((i, elm) => {
				$(elm).attr({
					"data-index": i + 1
				}).on("click", ".section-header", e => {
					const $header = $(e.currentTarget);
					if( $header.hasClass("no-anime") ) {
						return false;
					}
					
					$header.addClass("no-anime");
					setTimeout(() => $header.removeClass("no-anime"), 10000);
				});
			});
			
			this.setProp({ $sessionSections });
		}
	}
});

